import { IconBox } from "components/core/IconBox";
import Image from "next/image";
import { useState } from "react";

export function ChromeSearchInput() {
    const [search, setSearch] = useState("");

    return (
        <form
            className="flex h-12 w-full items-center gap-2.5 rounded-[75px]
                bg-secondary-contrast px-4 shadow-center-blur"
            onSubmit={(e) => {
                e.preventDefault();
                if (search.trim()) {
                    // Navigate to Google search
                    window.location.href = `https://www.google.com/search?q=${encodeURIComponent(
                        search
                    )}`;
                }
            }}
        >
            <IconBox size="large" name="SearchFilled" />
            <input
                className="flex-1 border-none bg-secondary-contrast text-sm
                    font-normal leading-6 outline-none
                    placeholder:text-text-disabled"
                type="text"
                value={search}
                placeholder="Google 검색"
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
            />
            <Image alt="google" src="/img/google.png" width={24} height={24} />
        </form>
    );
}
